import { Shield } from 'lucide-react';
import AdminUserManagement from './AdminUserManagement';

export default function AdminAdmins() {
  return (
    <AdminUserManagement
      role="admin"
      title="Admins"
      subtitle="Manage platform administrators"
      Icon={Shield}
      emptyText="No administrators found"
    />
  );
}
